import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Colors } from '../styles';
import { CircleCheckIcon } from '../atoms';
export const DailyTaskSubtask = ({ label, isComplete, onClick, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject), onClick: (e) => {
            if (!onClick) {
                return;
            }
            e.stopPropagation();
            onClick();
        } },
        React.createElement(CircleCheckIcon, { color: isComplete ? Colors.ProgressGreen : Colors.BackgroundGrayD, classObject: styles.checkIcon, filled: true }),
        React.createElement("span", { className: css(styles.label) }, label)));
};
const styles = StyleSheet.create({
    checkIcon: {
        width: 24,
        height: 24,
    },
    container: {
        padding: '12px 4px',
        borderRadius: 14,
        border: `1.5px solid ${Colors.BorderLightGray}`,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        justifyContent: 'center',
        alignItems: 'center',
    },
    label: {
        fontSize: 13,
        fontWeight: 'bold',
        lineHeight: '140%',
    },
});
